import {
  APIgetCollection,
  APIupdateCollection,
  APIdeleteCollections,
  APIgetCollectionGroups,
  APIgetCollections,
  APIremoveFilesFromCollection,
  APIdeleteCollectionGroupGroup,
  APIgetCollectionsTree,
  APIgetFeaturedCollections,
  APIsetCollectionFeaturedImage,
  APIsubscribeCollection,
  APIunsubscribeCollection,
  APIlikeCollection,
  APIunlikeCollection,
  APIdeleteCollectionsPermanent,
} from '../api/Collections';
import { APIgetFilesAsync } from '../api/Files';
import { APIupdateUserSettings } from '../api/User';

import { setUserSetting } from './Auth';

import { isArchive, isTrash } from '../helpers/App';
import { getCurrentUser } from '../helpers/Auth';
import { eventDispatch } from '../helpers/Events';
import { isAllFilesPage } from '../helpers/Files';
import { addFlashMessage } from '../helpers/FlashMessages';
import { getIntl } from '../helpers/IntlInstance';
import { getDefaultSortParams } from '../helpers/Sort';

export const GET_COLLECTION = 'GET_COLLECTION';
export const CLEAR_COLLECTION = 'CLEAR_COLLECTION';
export const SET_COLLECTION_LOADING = 'SET_COLLECTION_LOADING';
export const GET_COLLECTION_GROUPS = 'GET_COLLECTION_GROUPS';
export const GET_COLLECTION_GROUPS_ARCHIVED = 'GET_COLLECTION_GROUPS_ARCHIVED';
export const SET_COLLECTION_GROUPS_LOADING = 'SET_COLLECTION_GROUPS_LOADING';
export const GET_COLLECTIONS = 'GET_COLLECTIONS';
export const SET_COLLECTIONS_LOADING = 'SET_COLLECTIONS_LOADING';
export const CLEAR_COLLECTIONS = 'CLEAR_COLLECTIONS';
export const CLEAR_COLLECTIONS_LIST = 'CLEAR_COLLECTIONS_LIST';
export const GET_ALL_COLLECTIONS = 'GET_ALL_COLLECTIONS';
export const SET_COLLECTIONS_END = 'SET_COLLECTIONS_END';
export const SHOW_COLLECTION_EDIT_MODAL = 'SHOW_COLLECTION_EDIT_MODAL';
export const HIDE_COLLECTION_EDIT_MODAL = 'HIDE_COLLECTION_EDIT_MODAL';
export const SHOW_COLLECTION_ADD_MODAL = 'SHOW_COLLECTION_ADD_MODAL';
export const HIDE_COLLECTION_ADD_MODAL = 'HIDE_COLLECTION_ADD_MODAL';
export const SHOW_COLLECTION_MOVE_MODAL = 'SHOW_COLLECTION_MOVE_MODAL';
export const HIDE_COLLECTION_MOVE_MODAL = 'HIDE_COLLECTION_MOVE_MODAL';
export const REMOVE_FILES_FROM_COLLECTION = 'REMOVE_FILES_FROM_COLLECTION';
export const UPDATE_COLLECTION_ON_COLLECTIONS_LIST = 'UPDATE_COLLECTION_ON_COLLECTIONS_LIST';
export const UPDATE_COLLECTION_LIKES_ON_COLLECTIONS_LIST = 'UPDATE_COLLECTION_LIKES_ON_COLLECTIONS_LIST';
export const DELETE_COLLECTION_FROM_COLLECTIONS_LIST = 'DELETE_COLLECTION_FROM_COLLECTIONS_LIST';
export const DELETE_COLLECTIONS_FROM_COLLECTIONS_LIST = 'DELETE_COLLECTIONS_FROM_COLLECTIONS_LIST';
export const UPDATE_CURRENT_COLLECTION = 'UPDATE_CURRENT_COLLECTION';
export const SET_COLLECTIONS_ORDER = 'SET_COLLECTIONS_ORDER';
export const SET_COLLECTION_GROUP = 'SET_COLLECTION_GROUP';
export const SET_COLLECTION_FILTERS = 'SET_COLLECTION_FILTERS';
export const SET_SELECTED_COLLECTION_FILTERS = 'SET_SELECTED_COLLECTION_FILTERS';
export const CLEAR_COLLECTION_FILTERS = 'CLEAR_COLLECTION_FILTERS';
export const ADD_SELECTED_COLLECTION_FILTER = 'ADD_SELECTED_COLLECTION_FILTER';
export const REMOVE_SELECTED_COLLECTION_FILTER = 'REMOVE_SELECTED_COLLECTION_FILTER';
export const CLEAR_SELECTED_COLLECTION_FILTERS = 'CLEAR_SELECTED_COLLECTION_FILTERS';
export const SET_COLLECTIONS_PARAMS = 'SET_COLLECTIONS_PARAMS';
export const CLEAR_COLLECTIONS_PARAMS = 'CLEAR_COLLECTIONS_PARAMS';
export const GET_AVAILABLE_COLLECTION_FILTERS = 'GET_AVAILABLE_COLLECTION_FILTERS';
export const SET_COLLECTIONS_SEARCH_TYPE = 'SET_COLLECTIONS_SEARCH_TYPE';
export const SET_SIDEBAR_COLLECTION_OPEN = 'SET_SIDEBAR_COLLECTION_OPEN';
export const SET_SIDEBAR_COLLECTION = 'SET_SIDEBAR_COLLECTION';
export const SET_SIDEBAR_COLLECTION_FILES = 'SET_SIDEBAR_COLLECTION_FILES';
export const SET_SIDEBAR_COLLECTION_FILES_LOADING = 'SET_SIDEBAR_COLLECTION_FILES_LOADING';
export const ADD_FILES_TO_SIDEBAR_COLLECTION_FILES_LIST = 'ADD_FILES_TO_SIDEBAR_COLLECTION_FILES_LIST';
export const REMOVE_FILES_FROM_SIDEBAR_COLLECTION_FILES_LIST = 'REMOVE_FILES_FROM_SIDEBAR_COLLECTION_FILES_LIST';
export const CLEAR_SIDEBAR_COLLECTION_FILES_LIST = 'CLEAR_SIDEBAR_COLLECTION_FILES_LIST';
export const SET_SIDEBAR_COLLECTION_UPDATE = 'SET_SIDEBAR_COLLECTION_UPDATE';
export const SET_COLLECTION_GROUP_GROUPS = 'SET_COLLECTION_GROUP_GROUPS';
export const DELETE_COLLECTION_GROUP_GROUP_FROM_LIST = 'DELETE_COLLECTION_GROUP_GROUP_FROM_LIST';
export const SET_SELECTED_COLLECTIONS = 'SET_SELECTED_COLLECTIONS';
export const ADD_SELECTED_COLLECTION = 'ADD_SELECTED_COLLECTION';
export const ADD_SELECTED_COLLECTIONS = 'ADD_SELECTED_COLLECTIONS';
export const REMOVE_SELECTED_COLLECTION = 'REMOVE_SELECTED_COLLECTION';
export const CLEAR_SELECTED_COLLECTIONS = 'CLEAR_SELECTED_COLLECTIONS';
export const SET_SELECTED_ALL_COLLECTIONS = 'SET_SELECTED_ALL_COLLECTIONS';
export const SHOW_COLLECTION_GROUP_EDIT_MODAL = 'SHOW_COLLECTION_GROUP_EDIT_MODAL';
export const HIDE_COLLECTION_GROUP_EDIT_MODAL = 'HIDE_COLLECTION_GROUP_EDIT_MODAL';
export const UPDATE_COLLECTIONS_TREE = 'UPDATE_COLLECTIONS_TREE';
export const ADD_COLLECTION_TO_TREE = 'ADD_COLLECTION_TO_TREE';
export const UPDATE_COLLECTION_ON_TREE = 'UPDATE_COLLECTION_ON_TREE';
export const REMOVE_COLLECTION_FROM_TREE = 'REMOVE_COLLECTION_FROM_TREE';
export const CLEAR_COLLECTIONS_TREE = 'CLEAR_COLLECTIONS_TREE';
export const SET_COLLECTIONS_TREE_LOADING = 'SET_COLLECTIONS_TREE_LOADING';
export const GET_FEATURED_COLLECTIONS = 'GET_FEATURED_COLLECTIONS';
export const SET_FEATURED_COLLECTIONS_LOADING = 'SET_FEATURED_COLLECTIONS_LOADING';
export const SWAP_COLLECTIONS = 'SWAP_COLLECTIONS';

export const getCollection = collection => ({
  type: GET_COLLECTION,
  collection,
});

export const setCollectionLoading = status => ({
  type: SET_COLLECTION_LOADING,
  loading: status,
});

export const clearCollection = () => ({
  type: CLEAR_COLLECTION,
});

export const getCollectionGroups = collectionGroups => ({
  type: GET_COLLECTION_GROUPS,
  collectionGroups,
});

export const getCollectionGroupsArchived = collectionGroups => ({
  type: GET_COLLECTION_GROUPS_ARCHIVED,
  collectionGroups,
});

export const setCollectionGroupsLoading = status => ({
  type: SET_COLLECTION_GROUPS_LOADING,
  loading: status,
});

export const getCollections = (collections, total) => ({
  type: GET_COLLECTIONS,
  collections,
  total,
});

export const setCollectionsLoading = status => ({
  type: SET_COLLECTIONS_LOADING,
  loading: status,
});

export const getAllCollections = (collectionGroupId, collections) => ({
  type: GET_ALL_COLLECTIONS,
  collectionGroupId,
  collections,
});

export const clearCollections = (params) => ({
  type: CLEAR_COLLECTIONS,
  params,
});

export const clearCollectionsList = () => ({
  type: CLEAR_COLLECTIONS_LIST,
});

export const setCollectionsEnd = status => ({
  type: SET_COLLECTIONS_END,
  end: status,
});

export const showCollectionEditModal = () => ({
  type: SHOW_COLLECTION_EDIT_MODAL,
});

export const hideCollectionEditModal = () => ({
  type: HIDE_COLLECTION_EDIT_MODAL,
});

export const showCollectionAddModal = (move = false) => ({
  type: SHOW_COLLECTION_ADD_MODAL,
  move,
});

export const hideCollectionAddModal = () => ({
  type: HIDE_COLLECTION_ADD_MODAL,
});

export const showCollectionMoveModal = (collection) => ({
  type: SHOW_COLLECTION_MOVE_MODAL,
  collection,
});

export const hideCollectionMoveModal = () => ({
  type: HIDE_COLLECTION_MOVE_MODAL,
});

export const updateCollectionOnCollectionsList = collection => ({
  type: UPDATE_COLLECTION_ON_COLLECTIONS_LIST,
  collection,
});

export const updateCollectionLikesOnCollectionsList = collection => ({
  type: UPDATE_COLLECTION_LIKES_ON_COLLECTIONS_LIST,
  collection,
});

export const deleteCollectionFromCollectionsList = collection => ({
  type: DELETE_COLLECTION_FROM_COLLECTIONS_LIST,
  collection,
});

export const deleteCollectionsFromCollectionsList = collections => ({
  type: DELETE_COLLECTIONS_FROM_COLLECTIONS_LIST,
  collections,
});

export const updateCurrentCollection = collection => ({
  type: UPDATE_CURRENT_COLLECTION,
  collection,
});

export const setCollectionsOrder = (orderby, order) => ({
  type: SET_COLLECTIONS_ORDER,
  orderby,
  order,
});

export const setCollectionsParams = params => ({
  type: SET_COLLECTIONS_PARAMS,
  params,
});

export const clearCollectionsParams = params => ({
  type: CLEAR_COLLECTIONS_PARAMS,
  params,
});

export const setCollectionGroup = collectionGroupId => ({
  type: SET_COLLECTION_GROUP,
  collectionGroupId,
});

export const setCollectionFilters = filters => ({
  type: SET_COLLECTION_FILTERS,
  filters,
});

export const setSelectedCollectionFilters = selectedFilters => ({
  type: SET_SELECTED_COLLECTION_FILTERS,
  selectedFilters,
});

export const clearCollectionFilters = () => ({
  type: CLEAR_COLLECTION_FILTERS,
});

export const addSelectedCollectionFilter = filter => ({
  type: ADD_SELECTED_COLLECTION_FILTER,
  filter,
});

export const removeSelectedCollectionFilter = (filterType, filterKey) => ({
  type: REMOVE_SELECTED_COLLECTION_FILTER,
  filterType,
  filterKey,
});

export const clearSelectedCollectionFilters = () => ({
  type: CLEAR_SELECTED_COLLECTION_FILTERS,
});

export const getAvailableCollectionFilters = filters => ({
  type: GET_AVAILABLE_COLLECTION_FILTERS,
  filters,
});

export const setCollectionsSearchType = searchType => ({
  type: SET_COLLECTIONS_SEARCH_TYPE,
  searchType,
});

export const setSidebarCollectionOpen = open => ({
  type: SET_SIDEBAR_COLLECTION_OPEN,
  open,
});

export const setSidebarCollection = (collection, update = true) => ({
  type: SET_SIDEBAR_COLLECTION,
  collection,
  update,
});

export const setSidebarCollectionFiles = files => ({
  type: SET_SIDEBAR_COLLECTION_FILES,
  files,
});

export const setSidebarCollectionFilesLoading = loading => ({
  type: SET_SIDEBAR_COLLECTION_FILES_LOADING,
  loading,
});

export const addFilesToSidebarCollectionFilesList = files => ({
  type: ADD_FILES_TO_SIDEBAR_COLLECTION_FILES_LIST,
  files,
});

export const removeFilesFromSidebarCollectionFilesList = files => ({
  type: REMOVE_FILES_FROM_SIDEBAR_COLLECTION_FILES_LIST,
  files,
});

export const clearSidebarCollectionFilesList = () => ({
  type: CLEAR_SIDEBAR_COLLECTION_FILES_LIST,
});

export const setSidebarCollectionUpdate = update => ({
  type: SET_SIDEBAR_COLLECTION_UPDATE,
  update,
});

export const setCollectionGroupGroups = collectionGroupGroups => ({
  type: SET_COLLECTION_GROUP_GROUPS,
  collectionGroupGroups,
});

export const removeCollectionGroupGroupFromList = groupId => ({
  type: DELETE_COLLECTION_GROUP_GROUP_FROM_LIST,
  groupId,
});

export const setSelectedCollections = collections => ({
  type: SET_SELECTED_COLLECTIONS,
  collections,
});

export const addSelectedCollection = collection => ({
  type: ADD_SELECTED_COLLECTION,
  collection,
});

export const addSelectedCollections = collections => ({
  type: ADD_SELECTED_COLLECTIONS,
  collections,
});

export const removeSelectedCollection = collectionUuid => ({
  type: REMOVE_SELECTED_COLLECTION,
  collectionUuid,
});

export const clearSelectedCollections = () => ({
  type: CLEAR_SELECTED_COLLECTIONS,
});

export const setSelectedAllCollections = allCollectionsSelected => ({
  type: SET_SELECTED_ALL_COLLECTIONS,
  allCollectionsSelected,
});

export const showCollectionGroupEditModal = () => ({
  type: SHOW_COLLECTION_GROUP_EDIT_MODAL,
});

export const hideCollectionGroupEditModal = () => ({
  type: HIDE_COLLECTION_GROUP_EDIT_MODAL,
});

export const updateCollectionsTree = (parentUuid, collections, source) => ({
  type: UPDATE_COLLECTIONS_TREE,
  parentUuid,
  collections,
  source,
});

export const addCollectionToTree = (collection, source) => ({
  type: ADD_COLLECTION_TO_TREE,
  collection,
  source,
});

export const updateCollectionOnTree = (collection, source) => ({
  type: UPDATE_COLLECTION_ON_TREE,
  collection,
  source,
});

export const removeCollectionFromTree = (collectionUuid, source) => ({
  type: REMOVE_COLLECTION_FROM_TREE,
  collectionUuid,
  source,
});

export const clearCollectionsTree = (source = 'tree') => ({
  type: CLEAR_COLLECTIONS_TREE,
  source,
});

export const setCollectionsTreeLoading = loading => ({
  type: SET_COLLECTIONS_TREE_LOADING,
  loading,
});

export const getFeaturedCollections = collections => ({
  type: GET_FEATURED_COLLECTIONS,
  collections,
});

export const setFeaturedCollectionsLoading = loading => ({
  type: SET_FEATURED_COLLECTIONS_LOADING,
  loading,
});

export const swapCollections = (firstItem, secondItem) => ({
  type: SWAP_COLLECTIONS,
  firstItem,
  secondItem,
});

export const fetchCollectionGroups = (params = {}) => (dispatch) => {
  dispatch(getCollectionGroups([]));
  dispatch(setCollectionGroupsLoading(true));
  return APIgetCollectionGroups(params)
    .then((response) => {
      dispatch(getCollectionGroups(response.data));
      dispatch(setCollectionGroupsLoading(false));
      return response.data;
    })
    .catch(error => (error));
};

export const fetchCollectionGroupsArchived = (params = {}) => (dispatch) => {
  dispatch(getCollectionGroupsArchived([]));
  dispatch(setCollectionGroupsLoading(true));
  const rparams = params;
  rparams.archived = true;
  return APIgetCollectionGroups(rparams)
    .then((response) => {
      dispatch(getCollectionGroupsArchived(response.data));
      dispatch(setCollectionGroupsLoading(false));
      return response.data;
    })
    .catch(error => (error));
};

export const fetchCollections = (p = {}) => (dispatch, getState) => {
  const state = getState();

  if (isAllFilesPage()) {
    return false;
  }

  if (state.Collections.collectionsEnd) {
    return false;
  }

  dispatch(setCollectionsLoading(true));

  const params = { ...state.Collections.params };
  params.page += 1;
  if (isArchive()) {
    params.archived = true;
  }
  if (isTrash()) {
    params.trashed = true;
  }
  const { selectedAllCollections } = state.Collections;

  if (p.my === true) {
    params.my_collections = true;
  }

  const {
    orderby: filesOrderby,
    order: filesOrder,
  } = state.Files.params;
  params.orderby = filesOrderby;
  params.order = filesOrder;
  params.search_type = state.Collections.searchType;

  return APIgetCollections(null, {
    ...params,
    ...state.Collections.filters,
    ...state.Search,
  })
    .then((response) => {
      const { data } = response;
      if (data) {
        let collectionsTotal = 0;
        if (data.meta && data.meta.total) {
          collectionsTotal = data.meta.total;
        }
        dispatch(getCollections(data.data.data, collectionsTotal));
        if (selectedAllCollections && data.data.data) {
          dispatch(addSelectedCollections(data.data.data));
          if (data.meta.total <= data.meta.to) {
            dispatch(setSelectedAllCollections(false));
          }
        }
        dispatch(getAvailableCollectionFilters(data.data.filters));
        dispatch(setCollectionsLoading(false));
        if (data.meta && data.meta.last_page <= params.page) {
          dispatch(setCollectionsEnd(true));
        }
        dispatch(setCollectionsParams({ page: data.meta.current_page }));
        dispatch(setSelectedCollectionFilters(data.data.filters.selected_filters));
        if (data.data.filters.selected_filters.length > 0) {
          dispatch(setCollectionsSearchType('latest'));
        }
        if (data.data.latest_searches) {
          dispatch(setUserSetting({ latest_searches: data.data.latest_searches }));
        }
      }
      return response;
    })
    .catch(error => (error));
};

export const fetchCollection = (collectionUuid, params = {}) => (dispatch) => {
  dispatch(setCollectionLoading(true));
  return APIgetCollection(collectionUuid, params)
    .then((response) => {
      dispatch(getCollection(response.data));
      dispatch(setCollectionLoading(false));
      return response.data;
    });
};

export const removeFilesFromCollection = (collectionUuid, params) => () => (
  APIremoveFilesFromCollection(collectionUuid, params)
    .then((response) => (response.data))
    .catch(error => (error))
);

export const updateCollection = collection => () => (
  APIupdateCollection(collection)
    .then((response) => {
      updateCollectionOnCollectionsList(response.data);
      return response.data;
    })
    .catch(error => (error))
);

export const removeSidebarCollection = (collectionUuid = null) => (dispatch, getState) => {
  if (collectionUuid) {
    const state = getState();
    const { sidebarCollection } = state.Collections;
    if (!sidebarCollection || sidebarCollection.uuid !== collectionUuid) {
      return null;
    }
  }

  APIupdateUserSettings(getCurrentUser().uuid, { sidebar_collection_uuid: null });
  dispatch(setSidebarCollectionFiles([]));
  dispatch(setUserSetting({ sidebar_collection: null }));
  return dispatch(setSidebarCollection(null));
};

export const deleteCollections = ({
  collectionUuidList,
  progressCollectionsUuid,
  progressFilesUuid,
  withFiles = false,
}) => dispatch => (
  APIdeleteCollections({
    collectionUuidList,
    progressCollectionsUuid,
    progressFilesUuid,
    withFiles,
  }).then((response) => {
    collectionUuidList?.forEach((collectionUuid) => {
      dispatch(removeSidebarCollection(collectionUuid));
      dispatch(deleteCollectionFromCollectionsList({ uuid: collectionUuid }));
      dispatch(removeCollectionFromTree(collectionUuid, 'sidebar'));
    });
    eventDispatch('collectionsDeleted', response.data);
    return response.data;
  })
);

export const deleteCollectionsPermanent = ({
  collectionUuidList,
  progressCollectionsUuid,
  progressFilesUuid,
  withFiles = false,
}) => dispatch => (
  APIdeleteCollectionsPermanent({
    collectionUuidList,
    progressCollectionsUuid,
    progressFilesUuid,
    withFiles,
  }).then((response) => {
    collectionUuidList?.forEach((collectionUuid) => {
      dispatch(removeSidebarCollection(collectionUuid));
      dispatch(deleteCollectionFromCollectionsList({ uuid: collectionUuid }));
      dispatch(removeCollectionFromTree(collectionUuid, 'sidebar'));
    });
    eventDispatch('collectionsDeleted', response.data);
    return response.data;
  })
);

export const refreshCollections = () => (dispatch) => {
  dispatch(clearCollectionsList());
  dispatch(fetchCollections());
};

export const deleteSelectedCollectionFilter = (filterType, filterKey) => (dispatch, getState) => {
  const state = getState();
  const filters = { ...state.Collections.filters };
  if (filters[filterType] && window._.isArray(filters[filterType])) {
    const newFilters = filters[filterType].filter(f => (`${f}` !== `${filterKey}`));
    dispatch(setCollectionFilters({ [filterType]: newFilters }));
    dispatch(removeSelectedCollectionFilter(filterType, filterKey));
    dispatch(clearCollectionsList());
    dispatch(setCollectionsParams({ page: 0 }));
  } else if (filterType === 'search') {
    dispatch(removeSelectedCollectionFilter('search'));
    dispatch(clearCollectionsList());
    dispatch(setCollectionsParams({ page: 0 }));
  } else if (filterType === 'dates') {
    dispatch(setCollectionFilters({
      date: null,
      date_from: null,
      date_to: null,
    }));
    dispatch(removeSelectedCollectionFilter('dates'));
    dispatch(clearCollectionsList());
    dispatch(setCollectionsParams({ page: 0 }));
  }
};

export const clearAllCollectionFilters = () => (dispatch) => {
  dispatch(clearCollectionFilters());
  dispatch(clearSelectedCollectionFilters());
};

export const clearAllCollectionFiltersAndReload = () => (dispatch) => {
  dispatch(clearCollectionFilters());
  dispatch(clearSelectedCollectionFilters());
  dispatch(setCollectionsParams({ page: 0 }));
  dispatch(refreshCollections());
};

export const fetchSidebarCollectionFiles = collectionUuid => (dispatch) => {
  dispatch(setSidebarCollectionFilesLoading(true));
  dispatch(setSidebarCollectionUpdate(false));
  APIgetCollection(collectionUuid).then((response) => {
    const { data } = response;
    if (data) {
      dispatch(setSidebarCollection(data, false));
    }
  });
  return APIgetFilesAsync({
    collectionUuid,
    per_page: 0,
  })
    .then((response) => {
      const { data } = response;
      if (data && data.data) {
        dispatch(setSidebarCollectionFiles(data.data.data));
        dispatch(setSidebarCollectionFilesLoading(false));
        return data;
      }
      return response;
    })
    .catch(error => (error));
};

export const updateSidebarCollection = collection => (dispatch) => {
  APIupdateUserSettings(getCurrentUser().uuid, { sidebar_collection_uuid: collection.uuid });
  dispatch(setSidebarCollectionFiles([]));
  return dispatch(setSidebarCollection(collection));
};

export const deleteCollectionGroupGroup = groupId => () => (
  APIdeleteCollectionGroupGroup(groupId)
    .then(response => (response.data))
    .catch(error => (error))
);

export const getCollectionsTree = p => (dispatch) => {
  const params = p;
  const { parentUuid } = params;
  if (isArchive()) {
    params.archived = true;
  }
  const sortParams = getDefaultSortParams('collections', 'position', 'asc');
  if (sortParams && sortParams.orderby !== 'position') {
    params.orderby = sortParams.orderby;
    params.order = sortParams.order;
  }
  dispatch(setCollectionsTreeLoading(parentUuid));
  return APIgetCollectionsTree(params)
    .then((response) => {
      if (params.search) {
        dispatch(clearCollectionsTree(p.source));
      }
      dispatch(updateCollectionsTree(parentUuid, response.data, p.source));
      dispatch(setCollectionsTreeLoading(false));
      return response.data;
    })
    .catch(error => (error));
};

export const fetchFeaturedCollections = (params = {}) => (dispatch) => {
  if (!params.silent) {
    dispatch(setFeaturedCollectionsLoading(true));
  }
  return APIgetFeaturedCollections(params)
    .then((response) => {
      dispatch(getFeaturedCollections(response.data));
      dispatch(setFeaturedCollectionsLoading(false));
      return response.data;
    })
    .catch(error => (error));
};

export const setCollectionFeaturedImage = (collectionUuid, fileUuid) => dispatch => (
  APIsetCollectionFeaturedImage(collectionUuid, fileUuid).then((response) => {
    dispatch(updateCollectionOnCollectionsList(response.data));
    return response.data;
  })
);

export const subscribeCollection = collectionUuid => dispatch => (
  APIsubscribeCollection(collectionUuid).then((response) => {
    const intl = getIntl();
    dispatch(updateCollectionOnCollectionsList(response.data));
    addFlashMessage({
      type: 'success',
      text: intl.formatMessage({
        defaultMessage: 'You subscribed to the Collection',
      }),
    });
    return response.data;
  })
);

export const unsubscribeCollection = collectionUuid => dispatch => (
  APIunsubscribeCollection(collectionUuid).then((response) => {
    const intl = getIntl();
    dispatch(updateCollectionOnCollectionsList(response.data));
    addFlashMessage({
      type: 'success',
      text: intl.formatMessage({
        defaultMessage: 'You unsubscribed from the Collection',
      }),
    });
    return response.data;
  })
);

export const likeCollection = collectionUuid => dispatch => (
  APIlikeCollection(collectionUuid)
    .then((response) => {
      if (response.data) {
        dispatch(updateCollectionOnCollectionsList(response.data));
        eventDispatch('collectionUpdated', response.data);
        return response.data;
      }
      return response;
    })
    .catch(error => (error))
);

export const unlikeCollection = collectionUuid => dispatch => (
  APIunlikeCollection(collectionUuid)
    .then((response) => {
      if (response.data) {
        dispatch(updateCollectionOnCollectionsList(response.data));
        eventDispatch('collectionUpdated', response.data);
        return response.data;
      }
      return response;
    })
    .catch(error => (error))
);

export const switchCollectionLike = collection => (dispatch) => {
  if (collection.liked) {
    return dispatch(unlikeCollection(collection.uuid));
  }
  return dispatch(likeCollection(collection.uuid));
};
